import config from "../../config";
import axios from "axios";
import {setShopifyFavorites} from "./shopifyAC";
import underscore from "underscore";
import {setUserProfile} from "./myAccountAC";
import appErrorLogger from "../common/DataDogErrorLog";
import {trackDataEvents} from "./appAC";
import {getCookie} from "../common/utils";

const setAxiosInstance = () => {
    const auth_token = getCookie('auth_token');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6/`,
        timeout: 15000,
        headers: {'Authorization': auth_token}
    });
};

const saveFavorite = (product_id, favCount) => {
    const is_b2b = getCookie('is_b2b');
    return (dispatch, _) => {
        if (is_b2b) {
            dispatch(showVipModal(product_id, favCount))
        } else {
            if (favCount !== null) {
                const newFavCount = favCount + 1;
                localStorage.setItem(`fav_count_${product_id}`, newFavCount.toString());
            }
            const data = {
                'product_id': product_id
            };
            dispatch({
                type: "FAVORITE_LOADING",
                favorite_loading: true
            });

            setAxiosInstance().post(`favorites/`, data)
                .then((response) => {
                    dispatch({
                        type: "SET_FAVORITE",
                        product_id: product_id
                    });
                    dispatch({
                        type: "ADD_PROFILE_FAVORITES",
                        payload: product_id
                    });
                    dispatch({
                        type: "FAVORITE_LOADING",
                        favorite_loading: false
                    });
                })
                .then(() => {
                    trackDataEvents({
                        "event_type": "add_to_favorites",
                        "event_properties": {
                            "product_id": product_id
                        },
                        'ga_event': null
                    })
                })
                .catch((error) => appErrorLogger('Save Favorite failed', error))
        }
    }
}

const deleteFavorite = (product_id, favCount) => {
    return (dispatch, _) => {
        if (favCount !== null) {
            const newFavCount = favCount - 1;
            localStorage.setItem(`fav_count_${product_id}`, newFavCount.toString());
        }

        setAxiosInstance().delete(`favorites/${product_id}/`)
            .then((response) => {
                if(window.location.href.includes('my-account')){
                    window.location.reload()
                } else {
                    dispatch({
                        type: "REMOVE_FAVORITE",
                        product_id: product_id
                    })
                    dispatch({
                        type: "REMOVE_PROFILE_FAVORITES",
                        payload: product_id
                    })
                }
            }).catch((error) => appErrorLogger('Delete Favorite failed', error))
    }
}

const deleteMyAccountFavorite = (product_id) => {
    return (dispatch, _) => {
        setAxiosInstance().delete(`favorites/${product_id}/`)
            .then((response) => {
                window.location.reload();
            }).catch((error) => appErrorLogger('Delete My Account Favorite failed', error))
    }
};

const getB2bCollections = (collection_id, params) => {
    return (dispatch, _) => {
        setAxiosInstance().get("/my-account/b2b-collections/")
            .then((response) => {
                const default_collection = underscore.first(underscore.sortBy(response.data, "id"));
                dispatch({type: "HIDE_SMALL_SPINNER"});
                dispatch({
                    type: "SET_VIP_COLLECTIONS",
                    vip_collections: response.data,
                    default_collection: default_collection
                });
                return collection_id ? underscore.find(response.data, (collection) => {return collection.id === collection_id}) : default_collection
            })
            .then((response) => {
                dispatch(getB2bFavoritesByCollection(response.id, params))
            }).catch((error) => appErrorLogger('Get B2B Collection failed', error))
    }
};

const getB2bFavoritesByCollection = (collection_id, params) => {
    const shop_prefix = "gid://shopify/Product/";
    return (dispatch, _) => {
        setAxiosInstance().get("/my-account/b2b-collections/" + collection_id + "/favorites-p/", {params: params})
            .then((response) => {
                const {count, results} = response.data.favorites;
                dispatch({
                    type: 'GET_SHOPIFY_FAVORITES',
                    favorites_count: count
                });
                const product_ids = underscore.map(results, (product) => {
                    return btoa(shop_prefix + product.product_id);
                })
                dispatch(setShopifyFavorites(product_ids));
            }).catch((error) => appErrorLogger('Get B2B Favorites failed', error))
    }
}

const saveB2bCollection = (title, vip_collections) => {
    const data = {
        'name': title
    }
    const vip_collectons_names = underscore.pluck(vip_collections, 'name');
    const collection_exists = underscore.contains(vip_collectons_names, title);
    return (dispatch, _) => {
        if (title === "") {
            dispatch({
                type: "VIP_ERROR_MESSAGE",
                error_message: "Please name your list"
            })
        } else if(collection_exists) {
            dispatch({
                type: "VIP_ERROR_MESSAGE",
                error_message: "That favorite collections already exists. Please use a new name."
            })
        } else {
            dispatch({type: "SHOW_SMALL_SPINNER"});
            setAxiosInstance().post("/my-account/b2b-collections/", data)
                .then((response) => {
                    dispatch({
                        type: "VIP_ERROR_MESSAGE",
                        error_message: null
                    })
                    dispatch(getB2bCollections());
                    dispatch(toggleVipCollectionModal(false));
                }).catch((error) => appErrorLogger('Save B2B Collection failed', error))
        }
    }
};

const saveFavoriteToB2bCollection = (product_id, collection_id, vipModalFavCount) => {
    const data = {
        'product_id': product_id
    }
    if (vipModalFavCount !== null) {
        const newFavCount = vipModalFavCount + 1;
        localStorage.setItem(`fav_count_${product_id}`, newFavCount.toString());
    }
    return (dispatch, _) => {
        setAxiosInstance().put("/my-account/b2b-collections/" + collection_id + "/", data)
            .then((response) => {
                dispatch(hideVipModal());
                dispatch(getB2bCollections());
                dispatch(setUserProfile());
            }).catch((error) => appErrorLogger('Save Favorite To B2B Collection', error))
    }
};

const deleteFavoriteFromB2bCollection = (product_id, collection_id) => {
    const data = {
        'remove_product_id': product_id
    }
    return (dispatch, _) => {
        setAxiosInstance().put("/my-account/b2b-collections/" + collection_id + "/", data)
            .then((response) => {
                dispatch(getB2bCollections(collection_id));
            }).catch((error) => appErrorLogger('Delete Favorite From B2B Collection', error))
    }
};

const deleteB2bCollection = (collection_id) => {
    return (dispatch, _) => {
        setAxiosInstance().delete("/my-account/b2b-collections/" + collection_id + "/")
            .then((response) => {
                dispatch(hideVipModalDelete());
                dispatch(getB2bCollections());
            }).catch((error) => appErrorLogger('Delete B2B Collection', error))
    }
};

const exportB2bCollection = (collection_id, sort_by = null, filter_by = null) => {
    let url = "/my-account/b2b-collections/" + collection_id + "/favorites/export/"
    if (sort_by) {
        url = url + "?o=" + sort_by;
        if (filter_by && filter_by.key) {
            url = url + "&" + filter_by.key + '=' + filter_by.value;
        }
    } else if (filter_by && filter_by.key) {
        url = url + "?" + filter_by.key + '=' + filter_by.value;
    }
    return (dispatch, _) => {
        setAxiosInstance().get(url)
            .then((response) => {
                dispatch(showVipModalExport())
            }).catch((error) => appErrorLogger('Export B2B Collection', error))
    }
};

const showVipModal = (product_id=null, vipModalFavCount=null) => {
    return (dispatch, _) => {
        dispatch({
            type: "SHOW_VIP_ADD_TO_LIST_MODAL",
            product_id: product_id,
            vipModalFavCount: vipModalFavCount,
        })
        dispatch({
            type: "NO_SCROLL",
            no_scroll: true
        })
    }
}

const hideVipModal = () => {
    return (dispatch, _) => {
        dispatch({
            type: "HIDE_VIP_COLLECTIONS_MODAL"
        })
        dispatch({
            type: "NO_SCROLL",
            no_scroll: false
        })
    }
}

const showVipModalExport = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_EXPORT_MODAL",
            show_vip_export_modal: true
        })
    }
}

const hideVipModalExport = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_EXPORT_MODAL",
            show_vip_export_modal: false
        })
    }
}

const showVipModalDelete = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_DELETE_MODAL",
            show_vip_delete_modal: true
        })
    }
}

const hideVipModalDelete = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_DELETE_MODAL",
            show_vip_delete_modal: false
        })
    }
}

const showVipModalSoldout = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_SOLDOUT_MODAL",
            show_vip_soldout_modal: true
        })
    }
}

const hideVipModalSoldout = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_SOLDOUT_MODAL",
            show_vip_soldout_modal: false
        })
    }
}

const showVipModalClearCart = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_CLEAR_CART_MODAL",
            show_vip_clear_cart_modal: true
        })
    }
}

const hideVipModalClearCart = () => {
    return (dispatch, _) => {
        dispatch({
            type: "VIP_CLEAR_CART_MODAL",
            show_vip_clear_cart_modal: false
        })
    }
}

const toggleVipCollectionModal = (action) => {
    return (dispatch, _) => {
        dispatch({
            type: 'TOGGLE_VIP_ADD_COLLECTION_MODAL',
            payload: action
        })
    }
}

export {
    saveFavorite,
    deleteFavorite,
    deleteMyAccountFavorite,
    getB2bCollections,
    saveB2bCollection,
    saveFavoriteToB2bCollection,
    deleteFavoriteFromB2bCollection,
    showVipModal,
    hideVipModal,
    showVipModalExport,
    hideVipModalExport,
    showVipModalSoldout,
    hideVipModalSoldout,
    showVipModalClearCart,
    hideVipModalClearCart,
    showVipModalDelete,
    hideVipModalDelete,
    getB2bFavoritesByCollection,
    deleteB2bCollection,
    exportB2bCollection,
    toggleVipCollectionModal,
}